import { render, staticRenderFns } from "./SavingReasons.vue?vue&type=template&id=86f629a6&scoped=true"
import script from "./SavingReasons.vue?vue&type=script&lang=js"
export * from "./SavingReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f629a6",
  null
  
)

export default component.exports